import axios from 'axios'
import { useState } from 'react'
import authService from '../../../../Components/Login/auth.service'
import '../../../../styles/pages/SubMenuPages/SubMenuTipoDeObservacao/modal-tiposDeobservacoes/modalNovoGrupoDeQuestoes.css'

export default function Modal({ setOpenModal, modalInfo }) {
    var user = authService.getCurrentUser()
    let newDate = new Date()
    const [campos, setCampos] = useState({
        IdObservacaoGrupo: modalInfo.IdObservacaoGrupo,
        IdObservacaoTipo: modalInfo.IdObservacaoTipo,
        IdEmpresa: modalInfo.IdEmpresa,
        ogrNumero: modalInfo.ogrNumero,
        ogrDescricao: modalInfo.ogrDescricao,
        ogrStatus: modalInfo.ogrStatus,
        ogrObservacoes: modalInfo.ogrObservacoes,
        ogrAlteradoPor: user[0].pesEmail,
        ogrAlteradoEm: newDate
    })
    function handleInputChange(event) {
        if (event.target.name === 'ogrStatus') {
            if (event.target.checked) {
                campos[event.target.name] = 1
            } else {
                campos[event.target.name] = 0
            }
        } else {
            campos[event.target.name] = event.target.value
        }
        setCampos(campos)
    }

    function handleFormSubmit(event) {
        event.preventDefault()
        axios
            .post(
                process.env.REACT_APP_API_URL +
                '/api/v1/observacaogrupo/' +
                modalInfo.IdObservacaoGrupo,
                campos
            )
            .then(response => {
                if (response.status === 200) {
                    alert(response.data.message)
                    window.location.reload()
                } else {
                    alert(response.data.message)
                }
            })
    }

    return (
        <>
            <div className="overlay">
                <div className="modalPadrao-content">
                    <div className="cxTituloPadrao">
                        <h1>
                            Editar Grupo De Questões
                            <hr className="hrTitleModal" />
                        </h1>
                        <button className="close-modal" onClick={() => { setOpenModal(false) }}>
                            X
                        </button>
                    </div>

                    <form onSubmit={handleFormSubmit}>

                        <div className="linhaTipObs" style={{ width: '100%' }}>
                            <tr>
                                <th><label>Ordem</label></th>
                                <th><label>Descrição:</label></th>
                            </tr>
                            <tr>
                                <td>
                                    <input
                                        type="number"
                                        id="ogrNumero"
                                        name="ogrNumero"
                                        min={1}
                                        required
                                        onChange={handleInputChange}
                                        defaultValue={campos.ogrNumero}
                                    ></input>
                                </td>
                                <td style={{ width: 780 }}>
                                    <input
                                        type="text"
                                        id="ogrDescricao"
                                        name="ogrDescricao"
                                        required
                                        onChange={handleInputChange}
                                        defaultValue={campos.ogrDescricao}
                                    ></input>
                                </td>
                            </tr>
                        </div>

                        <label>
                            Observações:
                        </label>
                        <textarea
                            type="text"
                            id="ogrObservacoes"
                            name="ogrObservacoes"
                            row="none"
                            maxLength="500"
                            onChange={handleInputChange}
                            defaultValue={campos.ogrObservacoes}
                        ></textarea>
                        <div className="caixaSalvarPadrao">
                            <div className="InputAuthorization1">
                                <label>
                                    <input
                                        name="ogrStatus"
                                        type="checkbox"
                                        onChange={handleInputChange}
                                        defaultChecked={!!campos.ogrStatus} />
                                    <span style={{ position: 'relative' }}>
                                        Status do Registro
                                    </span>
                                </label>
                            </div>
                            <button typeof="submit">
                                Salvar Grupo
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}